import { UserDocument } from "models/UserDocument"

export const EXECUTOR_VERIFICATION_SUBMITTED_ID = 1
export const EXECUTOR_VERIFICATION_IN_REVIEW_ID = 2
export const EXECUTOR_VERIFICATION_IN_PROGRESS_ID = 6
export const EXECUTOR_VERIFICATION_NOT_STARTED_ID = 5
export const EXECUTOR_VERIFICATION_ACCEPTED_ID = 3
export const EXECUTOR_VERIFICATION_REJECTED_ID = 4

export const EXECUTOR_VERIFICATION_STEP_BASIC_INFO_ID = 1
export const EXECUTOR_VERIFICATION_STEP_PHOTO_VERIFIATION_ID = 2
export const EXECUTOR_VERIFICATION_STEP_GOVT_ID_ID = 3
export const EXECUTOR_VERIFICATION_STEP_DEATH_CERTIFICATE = 4
export const EXECUTOR_VERIFICATION_STEP_WILL = 5
export const EXECUTOR_VERIFICATION_STEP_LETTERS_OR_AGREEMENT = 6

export enum ExecutorVerificationSteps {
  UNKNOWN = -1,
  EXECUTOR_VERIFICATION_STEP_BASIC_INFO_ID = 1,
  EXECUTOR_VERIFICATION_STEP_PHOTO_VERIFIATION_ID = 2,
  EXECUTOR_VERIFICATION_STEP_GOVT_ID_ID = 3,
  EXECUTOR_VERIFICATION_STEP_DEATH_CERTIFICATE = 4,
  EXECUTOR_VERIFICATION_STEP_WILL = 5,
  EXECUTOR_VERIFICATION_STEP_LETTERS_OR_AGREEMENT = 6,
}

const ExecutorVerificationScreen = (): JSX.Element => {
  return <></>;
};

export default ExecutorVerificationScreen;


/**
 * Gets the most recent document and document src string.  Assumes the passed in arrays are sorted ascending by updated-at date.
 */
export function findMostRecentDoc(docs: UserDocument[], docTypeId: number): UserDocument | null {
  // For some reason findLastIndex is giving me an error so I'll just do a loop
  for (let i = docs.length - 1; i >= 0; i--) {
    if (docs[i].documentTypeId === docTypeId) {
      return docs[i]
    }
  }

  console.warn("didn't find most recent doc of type " + docTypeId)

  return null
}